import {Reporter, ReportOpts} from '../Reporter';
import {getContext} from '../util';

const url = process.env.LOGGING_API_URL!;

export class LoggingReporter implements Reporter {
    public report({severity, message, error, extra}: ReportOpts) {
        const body = JSON.stringify({
            '@timestamp': new Date().toISOString(),
            message,
            error: error?.toString(),
            severity,
            ...getContext(),
            ...extra,
        });
        const headers = {
            'Content-Type': 'application/json',
            'Access-Control-Request-Method': 'POST',
        };
        fetch(url, {method: 'POST', body, headers}).catch(e => console.warn(e));
    }
}
